<form [formGroup]="comentarForm">
    <h2 style="width: 375px;" mat-dialog-title>A&ntilde;adir ciudadano</h2>
    <mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-label>C&eacute;dula/RUC</mat-label>
            <input matInput formControlName="ciruc" (keydown.enter)="onKeydown($event)"/>
            @if (loading) {
            <mat-spinner matSuffix diameter="20"></mat-spinner>
            } @else{
              <button type="button" mat-icon-button matSuffix matTooltip="Buscar" (click)="onBuscar()" [disabled]="comentarForm.controls.ciruc.disabled" >
                <mat-icon>search</mat-icon>
              </button>
            }
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Nombres</mat-label>
            <input matInput formControlName="nombres" />
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Apellido</mat-label>
            <input matInput formControlName="apellidos" />
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Correo electrónico</mat-label>
            <input type="email" matInput formControlName="correo" />
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Tel&eacute;fono</mat-label>
            <input type="tel" matInput formControlName="telefono" />
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Tratamiento/Título</mat-label>
            <input type="text" matInput formControlName="tratamientoTitulo" />
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Cargo</mat-label>
            <input type="text" matInput formControlName="cargo" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
        <button type="submit" mat-flat-button (click)="onSubmitForm()"
            [disabled]="!comentarForm.valid || fetchingAddCiudadano">
            <div class="btn-login-content">
                @if (fetchingAddCiudadano) {
                <mat-spinner diameter="20" color="warn"></mat-spinner>
                }@else{
                <p>Aceptar</p>
                }
            </div>
        </button>
    </mat-dialog-actions>
</form>
